const isApp = typeof navigator !== 'undefined' && !!navigator.userAgent.match(/(Mdi Native Shell)/);

export default isApp;
